export default {"src":"/_next/static/media/we-money-award.f005b517.svg","height":95,"width":95};